import {useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import {DISPATCH_ACTION, usePayPalScriptReducer} from '@paypal/react-paypal-js';

const PaypalInitializer = ({paypalClientId, btToken}) => {
  const initializedRef = useRef(null);
  const [{options}, dispatchPaypal] = usePayPalScriptReducer();

  useEffect(() => {
    if (!initializedRef.current && paypalClientId && btToken) {
      initializedRef.current = true;
      dispatchPaypal({
        type: DISPATCH_ACTION.RESET_OPTIONS,
        value: {
          ...options,
          clientId: paypalClientId,
          dataClientToken: btToken,
        },
      });
    }
  }, [paypalClientId, btToken, options, dispatchPaypal]);

  return null;
};

PaypalInitializer.propTypes = {
  /** PayPal client Id */
  paypalClientId: PropTypes.string,

  /** Braintree client token */
  btToken: PropTypes.string,
};

export default PaypalInitializer;
